import { render, staticRenderFns } from "./TepViajeTransportadora.vue?vue&type=template&id=df6dda68"
import script from "./TepViajeTransportadora.vue?vue&type=script&lang=js"
export * from "./TepViajeTransportadora.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports